import React, { useState } from "react";

const LedgerViewer = () => {
  const [driveLink, setDriveLink] = useState("");
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadLedger = async () => {
    if (!driveLink) {
      alert("Enter Google Drive link");
      return;
    }

    setLoading(true);

    const fd = new FormData();
    fd.append("driveLink", driveLink);

    const res = await fetch(
      "https://www.d-rosa.ai/read-ledger-from-drive",
      {
        method: "POST",
        body: fd
      }
    );

    const data = await res.json();
    if (data.success) {
      setLedgers(data.ledgers);
    }

    setLoading(false);
  };

  const blueColor = "#1E3A8A"; // Professional Blue

  return (
    <div style={{ maxWidth: 900, margin: "auto", padding: 20 }}>
      <h2 style={{ color: blueColor }}>Ledger Viewer</h2>

      <input
        style={{ width: "100%", padding: 10 }}
        placeholder="Google Drive Folder Link"
        value={driveLink}
        onChange={e => setDriveLink(e.target.value)}
      />

      <button
        onClick={loadLedger}
        style={{
          marginTop: 15,
          padding: 10,
          backgroundColor: blueColor,
          color: "white",
          border: "none",
          cursor: "pointer"
        }}
      >
        Load Ledger
      </button>

      {loading && <p>Loading...</p>}

      {ledgers.map((ledger, i) => (
        <div key={i} style={{ marginTop: 30 }}>
          <h3>{ledger.accountName}</h3>
          <p>
            <b>Account Type:</b> {ledger.accountType}
          </p>

          <table width="100%" border="1" cellPadding="6">
            <thead>
              <tr>
                <th>Date</th>
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              {ledger.rows.map((r, idx) => (
                <tr key={idx}>
                  <td>{r.date || "-"}</td>
                  <td>{r.debit || "-"}</td>
                  <td>{r.credit || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default LedgerViewer;